import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'AgentProfileEditor',
  properties: {},

  statics: {
    breadcrumb: 'Agent Profile',
  },
});
